<template>
  <div>
    <a href="javascript:void(0)" rel="external nofollow" @click="goBlogDetail">
      <el-card  style="margin: 20px 10px;height:80px">
        <div style="height: 40px;">

<!--          <div style="width: 100%;display: flex">-->
            <div class="title">{{title}}</div>

            <div class="react topping" v-if="topping == true" style="float:left;">置顶</div>

            <div class="react essence" v-if="essence == true" style="float:left;">精华</div>
<!--          </div>-->

          <div v-for="item in tags" :key="item.id">
            <el-tooltip class="item" effect="dark" :content="item.tag_name" placement="top">
              <div class="circular" :style="getColorStyle(item.tag_col)"></div>
            </el-tooltip>
          </div>

          <div class="time">{{createTime}}</div>

        </div>
      </el-card>
    </a>

  </div>
</template>

<script>
import Utils from '../../../../js/Utils'
export default {
  name: 'BlogItem',
  props: {
    data: Object
  },
  data () {
    return {
      title: this.data.title,
      createTime: Utils.formatDate(this.data.create_blog_time, 'YYMMDD'),
      topping: this.data.topping,
      essence: this.data.essence,
      tags: this.data.tags
    }
  },
  methods: {
    goBlogDetail () {
      this.$router.push({path: '/blog/blog_info', name: 'BlogInfo', query: {blog_id: this.data.id}})
    },
    getColorStyle (color) {
      return 'background-color:' + color
    }
  }
}
</script>

<style scoped>

.title{
  float: left;
  font-size: 20px;
  font-weight: bold;
  margin-top: 6px;
  margin-right: 10px;
  white-space: nowrap; overflow: hidden; text-overflow: ellipsis;
}

.time{
  color: #909399;
  float: right;
  margin-left: 30px;
  margin-top: 9px;
  width: 100px;
}

.topping{
  background: dodgerblue;
}
.essence{
  background: red;
}
/*.react {*/
/*  width: 25px;*/
/*  height: 32px;*/
/*  margin-right: 5px;*/
/*  text-align: center;*/
/*  transform: skewX(-20deg);*/
/*  margin-top: 4px;*/
/*}*/

.react {
  width: 24px;
  height: 16.5px;
  padding: 3px 10px;
  margin-right: 5px;
  text-align: center;
  /*transform: skewX(-20deg);*/
  margin-top: 8.5px;

  font-size: 12px;
  border-radius: 5px;
  color: white;
}

.circular{
  border-radius: 12px;
  border:1px solid white;
  width: 22px;
  height: 22px;
  float: right;
  margin-right: -10px;
  margin-top: 8px;
}

</style>



// WEBPACK FOOTER //
// src/components/pc/pages/blog/BlogItem.vue